import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/legalentitydatareplicator-general-types/legalentitydatareplicator/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
